import { useCallback, useEffect, useRef, useState } from 'react';

type UseCountdownReturn = {
	countdown: number;
	setCountdown: (seconds: number) => void;
};

export function useCountdown(initialValue = 0): UseCountdownReturn {
	const [countdown, _setCountdown] = useState<number>(initialValue);
	const intervalRef = useRef<NodeJS.Timeout | null>(null);

	const clear = () => {
		if (intervalRef.current) {
			clearInterval(intervalRef.current);
			intervalRef.current = null;
		}
	};

	const setCountdown = useCallback(
		(seconds: number) => {
			clear();
			_setCountdown(seconds);

			if (seconds > 0) {
				intervalRef.current = setInterval(() => {
					_setCountdown(prev => {
						if (prev <= 1) {
							clear();
							return 0;
						}
						return prev - 1;
					});
				}, 1000);
			}
		},
		[countdown],
	);

	useEffect(() => {
		setCountdown(initialValue);
		return () => clear(); // cleanup on unmount
	}, []);

	return { countdown, setCountdown };
}
